<template>
      <div no-body class="lku-ap"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
          <b-input-group >
            <b-input-group-prepend><span class="ml-2 pt-1">Filter &nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" size="sm" placeholder="Payment Number"></b-form-input>
                <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" size="sm" placeholder="Description" class="ml-1"></b-form-input>
                <b-form-input v-model="tblData.customer" @keyup.13.native="refresh()" size="sm" placeholder="Customer" class="ml-1"></b-form-input>
                <b-form-input v-model="tblData.reference" @keyup.13.native="refresh()" size="sm" placeholder="Reference" class="ml-1"></b-form-input>
              <b-input-group-append><b-button variant="success" size="sm" class="ml-1"@click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
              <b-input-group-append><b-button variant="secondary" size="sm" class="ml-1" @click="clearFilter()" >Clear Filter</b-button></b-input-group-append>
          </b-input-group>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblArset"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(tglpaym)="data">
          {{ data.item.tglpaym | moment("DDMMMYYYY") }}
        </template>
          <template v-slot:cell(totalbyr)="data">
            {{data.item.matauang}} {{data.item.totalbyr | numFormat}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-ap {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import arpayment from "../../apis/arpayment";

export default {
  data() {
    return {
      fields: [
          {
            key: "paymno",
            thStyle: "width:100px",
            label: "Settle. Number",
            sortable: true
          },
          {
            key: "tglpaym",
            label: "Paym.Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            thStyle: "width:220px",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "reference",
            label: "Reff.#",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "bankasal",
            label: "Customer Bank",
            sortable: true
          },
          {
            key: "totalbyr",
            label: "Payment Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'paymno',
        sortDesc: false,status:'0'
      },
      updatetable:false,
      lkuLoading:false
    };
  },
  computed: {
    // filterCustomer() {
    //   return this.tblData.customer;
    // },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.data();
    },   
    limitchange: function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },  
  props: ["formdata"],
  created: async function() {
      if (this.formdata.items)
      {
          for (var key in this.formdata) {
              this.tblData[key] = this.formdata[key];
          }
      } else {
        this.data();
      }
  },  
  methods: {
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter(ctx) {
        this.tblData.reference= '';
        this.tblData.kodebank=  '';
        this.tblData.namabank=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.invoice=  '';
        this.refresh();
    },    
    data: async function(){
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      this.tblData.items= await arpayment.list(this.tblData);      
      this.lkuLoading = false;
      this.updatetable=!this.updatetable;
    },
    refresh: async function(ctx) {
      this.data();
      this.$refs.tblArset.refresh();
    }
  }
};
</script>
